import React from 'react'
import AvailableCard from '../Components/AvailableCard'

const Adopt = () => {
  return (
    <div className='text-center my-8 px-4 md:px-8 lg:px-16'>
      <h1 className='font-semibold text-2xl md:text-3xl flex justify-center items-center'>
        Akoi Dogs For Adoption
        <img 
          src="/assets/paws.jpg" 
          alt="pawImage"
          className='w-6 h-6 md:w-8 md:h-8 mx-2'
        />
      </h1>

      {/* <p className='font-semibold my-4 text-gray-600 text-sm md:text-base lg:text-lg max-w-3xl mx-auto'>
        "We are dedicated to promoting animal adoption and are actively working to launch our adoption program. Please bear with us as we prepare to make this service available soon. Thank you for your patience and support!"
      </p> */}

      <div>
        <AvailableCard/>
      </div>
    </div>
  )
}

export default Adopt
